<template>
  <div>
    <el-card v-loading="isLoading || isUpdating">
      <!-- <label class="label">選擇專案</label> -->
      <div class="flex-row" style="margin-bottom: 1rem">
        <!-- <el-select
          v-model="selectedProject"
          @change="readProjectImage"
          filterable
          style="margin-right: 10px; flex: 1"
        >
          <el-option
            v-for="item in projectList"
            :key="item.value"
            :label="item.project_id"
            :value="item._id"
          />
        </el-select> -->
        
        <el-button 
          v-if="selectedProject" 
          type="warning" 
          icon="el-icon-document-copy" 
          @click="openImportDialog"
        >
          從其他專案匯入
        </el-button>
      </div>

      <el-upload
        ref="upload"
        v-if="selectedProject"
        :http-request="uploadImage"
        :before-upload="onBeforeUpload"
        :on-success="uploadSuccess"
        :before-remove="removeImage"
        :on-remove="readProjectImage"
        :file-list="fileList"
        action="123"
        multiple
        name="image"
        accept="image/jpeg,image/png"
        class="upload-demo"
        list-type="picture-card"
      >
        <el-button size="small" type="primary">點擊上傳</el-button>
      </el-upload>

      <div class="image-grid">
        <div v-for="file in fileList" :key="file._id" class="image-item">
            <el-card :body-style="{ padding: '0px' }">
            <div slot="header">
              <div class="flex-row justify-between align-center">
                <div class="flex-column">
                  <span class="image-title is-marginless">{{ file.name }}</span>
                  <span class="is-size-7 is-marginless">{{ file.description }}</span>
                </div>
                <div class="flex-row">
                  <el-button @click.native="showDialog(file, 'CreateForm')" type="primary">
                    新增燈號
                  </el-button>
                  <el-button @click.native="showDialog(file, 'VectorForm')" type="primary">
                    設定向量
                  </el-button>
                  <el-button
                    @click.native="showDialog(file, 'EditImage')"
                    icon="el-icon-edit"
                    size="mini"
                    type="success"
                  />
                </div>
              </div>
            </div>

            <div class="image-container">
              <image-marker
                :project="selectedProject"
                :file="file"
                :disable-popover="false"
                @reload="readProjectImage"
              />
            </div>
          </el-card>
        </div>
      </div>
    </el-card>

    <info-dialog
      v-if="dialogVisible"
      :dialog-visible="dialogVisible"
      :file="currentFile"
      :file-list="fileList"
      :action-type="actionType"
      :project-list="projectList"
      :project="selectedProject"
      :editing-project="selectedProject"
      @reload="readProjectImage"
      @close="dialogVisible = false"
    />

    <el-dialog
      title="從其他專案匯入圖片"
      :visible.sync="importDialogVisible"
      width="70%"
      append-to-body
    >
      <div v-loading="isImportLoading">
        <label class="label">來源專案</label>
        <el-select
          v-model="importSourceProject"
          placeholder="請選擇來源專案"
          filterable
          @change="fetchSourceImages"
          style="width: 100%; margin-bottom: 20px;"
        >
          <el-option
            v-for="item in projectList"
            :key="item.value"
            :label="item.project_id"
            :value="item._id"
            :disabled="item._id === selectedProject" 
          />
          </el-select>

        <div v-if="sourceImageList.length > 0" class="import-grid">
           <el-checkbox-group v-model="selectedImagesToImport">
            <div 
              v-for="img in sourceImageList" 
              :key="img._id" 
              class="import-item"
              :class="{ 'is-selected': selectedImagesToImport.includes(img) }"
            >
              <el-checkbox :label="img" class="import-checkbox">
                 <div class="import-preview">
                    <img :src="img.url" />
                    <span class="import-name">{{ img.name }}</span>
                 </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div v-else-if="importSourceProject" class="no-data">
          此專案無圖片
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button 
          type="primary" 
          @click="executeImport" 
          :disabled="selectedImagesToImport.length === 0 || isImportLoading"
        >
          確認匯入 ({{ selectedImagesToImport.length }})
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ImageMarker from '@/components/pin/ImageMarker';
import InfoDialog from '@/components/pin/InfoDialog';

export default {
  components: {
    ImageMarker,
    InfoDialog,
  },
  data() {
    return {
      selectedProject: '',
      currentFile: {},
      fileList: [],
      dialogVisible: false,
      isLoading: false,
      isUpdating: false,
      instrumentList: [],
      actionType: 'edit',
      importDialogVisible: false,
      importSourceProject: '',
      sourceImageList: [],
      selectedImagesToImport: [],
      isImportLoading: false,
    };
  },
  computed: {
    projectList() {
      return this.$store.getters['project/projectList'];
    },
    selectedProjectDetails() {
      return this.projectList.find(ele => ele._id === this.selectedProject);
    },
  },
  watch: {
    fileList(newValue, oldValue) {
      if (this.currentFile && newValue.length && oldValue.length) {
        this.currentFile = newValue.find(file => file._id === this.currentFile._id);
      }
    },
  },
  async mounted() {
    this.selectedProject = this.$store.state.project.selectedProject._id;
    this.readProjectImage();
  },
  methods: {
    openImportDialog() {
      this.importDialogVisible = true;
      this.importSourceProject = '';
      this.sourceImageList = [];
      this.selectedImagesToImport = [];
    },
    fetchSourceImages(projectId) {
      if (!projectId) return;
      this.isImportLoading = true;
      this.sourceImageList = [];
      
      this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${projectId}/image`,
      }).then(res => {
        if (res.data) {
          this.sourceImageList = res.data.map(ele => ({
            _id: ele._id,
            name: ele.name,
            url: `${process.env.VUE_APP_IMAGE_BASE_URL}/layout/${ele.path}`,
            description: ele.description,
            originalPath: ele.path,
            marker: ele.marker || [],
          }));
        }
      }).finally(() => {
        this.isImportLoading = false;
      });
    },
    async executeImport() {
      if (this.selectedImagesToImport.length === 0) return;
      
      this.isImportLoading = true;
      let successCount = 0;

      try {
        for (const imgObj of this.selectedImagesToImport) {
          await this.processSingleImport(imgObj);
          successCount++;
        }
        
        this.$notifySuccess(`成功匯入 ${successCount} 張圖片`);
        this.importDialogVisible = false;
        this.readProjectImage();
        
      } catch (error) {
        console.error(error);
        this.$notifyError('匯入過程中發生錯誤');
      } finally {
        this.isImportLoading = false;
      }
    },
    async processSingleImport(imgObj) {
      // console.log(`正在處理: ${imgObj.name}`);
      const response = await fetch(imgObj.url);
      const blob = await response.blob();
      const file = new File([blob], imgObj.name, { type: blob.type });

      const formData = new FormData();
      formData.append('image', file);

      try {
        await this.$axios({
          method: 'post',
          apiName: `/admin/project/${this.selectedProject}/image`,
          data: formData,
        });
      } catch (e) {
        console.error('圖片上傳失敗', e);
        return;
      }

      let newImageId = null;
      try {
        const res = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `${this.selectedProject}/image`,
        });

        if (res.data && Array.isArray(res.data)) {
          const candidates = res.data.filter(img => img.name === imgObj.name);

          if (candidates.length > 0) {
            candidates.sort((a, b) => (a._id > b._id ? -1 : 1));
            newImageId = candidates[0]._id;
          }
        }
      } catch (err) {
        console.error('無法讀取圖片列表以確認 ID', err);
      }

      if (!newImageId) {
        console.warn('找不到新圖片 ID，跳過燈號建立');
        return;
      }

      if (imgObj.marker && imgObj.marker.length > 0) {
        const pinPromises = imgObj.marker.map(async (pinData) => {
          let instrumentIds = [];
          if (Array.isArray(pinData.instrument)) {
            instrumentIds = pinData.instrument.map(i => (typeof i === 'object' ? i._id : i));
          }

          const payload = {
            imageId: newImageId,
            x: pinData.x,
            y: pinData.y,
            shape: pinData.shape || 'square',
            size: pinData.size || 'medium',
            border_color: pinData.border_color || 'white',
            markerId: '',
            instrument: instrumentIds, 
          };

          try {
            await this.$axios({
              category: 'project',
              method: 'post',
              apiName: `${this.selectedProject}/createImageMarker`,
              data: payload,
            });
          } catch (err) {
            payload.instrument = [];
            try {
              await this.$axios({
                category: 'project',
                method: 'post',
                apiName: `${this.selectedProject}/createImageMarker`,
                data: payload,
              });
            } catch (retryErr) {
              console.error('燈號建立失敗', retryErr);
            }
          }
        });

        await Promise.all(pinPromises);
      }
      
      return true;
    },
    showDialog(file, type) {
      this.dialogVisible = true;
      this.currentFile = file;
      this.actionType = type;
    },
    readProjectImage() {
      return this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${this.selectedProject}/image`,
      }).then(res => {
        if (res.data) {
          this.fileList = res.data.map(ele => ({
            _id: ele._id,
            name: ele.name,
            url: `${process.env.VUE_APP_IMAGE_BASE_URL}/layout/${ele.path}`,
            description: ele.description,
            marker: ele.marker,
          }));
        } else this.fileList = [];
      });
    },
    uploadImage(param) {
      this.isUpdating = true;
      const file = param.file;
      const formData = new FormData();
      formData.append('image', file);

      this.$axios({
        method: 'post',
        apiName: `/admin/project/${this.selectedProject}/image`,
        data: formData,
      })
        .then(res => param.onSuccess(res, file))
        .catch(error => param.onError(error));
    },
    async uploadSuccess() {
      this.$notifySuccess('圖片上傳成功');
      await this.$refs.upload.clearFiles();
      await this.readProjectImage();
      this.isUpdating = false;
    },
    async removeImage(file) {
      await this.$confirm('是否刪除此照片？', '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          return this.$axios({
            method: 'delete',
            apiName: `/admin/project/${this.selectedProject}/image/${file._id}`,
          })
            .then(() => {
              this.$notifySuccess('刪除成功');
              this.readProjectImage();
              return true;
            })
            .catch(error => {
              this.$notifyError('刪除失敗', error?.response?.data?.message);
            });
        })
        // eslint-disable-next-line no-empty-function
        .catch(() => {});
    },
  },
};
</script>

<style lang="stylus">
.image-title
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

.el-upload-list__item-thumbnail
  object-fit cover

.image-grid
  display grid
  grid-template-columns 1fr
  grid-gap 20px
  align-items stretch

.image-item
  display flex
  flex-direction column

.el-card
  height 100%
  display flex
  flex-direction column

.image-container
  position relative
  flex-grow 1
  display block
  overflow auto
  background-color #f3f4f6
  ::v-deep img,
  ::v-deep canvas,
  ::v-deep svg
    max-width none
    max-height none
    width auto
    height auto

.image-container img
  max-width none !important
  max-height none !important
  width auto !important
  height auto !important
  display block

.image-container canvas,
.image-container .marker-layer,
.image-container .pin-layer
  position absolute
  top 0
  left 0

.import-grid
  display grid
  grid-template-columns repeat(auto-fill, minmax(150px, 1fr))
  grid-gap 15px
  max-height 500px
  overflow-y auto
  padding 10px
  border 1px solid #eee

.import-item
  border 1px solid #dcdfe6
  border-radius 4px
  padding 5px
  cursor pointer
  transition all 0.3s
  position relative
  
  &:hover
    border-color #409EFF
    box-shadow 0 2px 12px 0 rgba(0,0,0,.1)
    
  &.is-selected
    border-color #409EFF
    background-color #ecf5ff

.import-checkbox
  width 100%
  height 100%
  display flex
  align-items flex-start
  
  ::v-deep .el-checkbox__input
    position absolute
    top 10px
    right 10px
    z-index 10
  
  ::v-deep .el-checkbox__label
    width 100%
    padding-left 0 !important

.import-preview
  display flex
  flex-direction column
  align-items center
  
  img
    width 100%
    height 120px
    object-fit cover
    border-radius 2px
    margin-bottom 5px

.import-name
  font-size 12px
  color #606266
  text-align center
  word-break break-all
  line-height 1.2
  height 2.4em
  overflow hidden

.no-data
  text-align center
  padding 20px
  color #909399
</style>
